import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { forkJoin, Observable } from 'rxjs';
import { HttpService } from '../service/http.service';
import { WpBookingRequest } from '../wp-booking-request';
import { WpBookingRequestSearchOptions } from '../wp-booking-request-search-options';
import { SalesAgent } from '../sales-agent';

@Component({
  selector: 'app-wp-booking-requests',
  templateUrl: './wp-booking-requests.component.html',
  styleUrls: ['./wp-booking-requests.component.css']
})
export class WpBookingRequestsComponent implements OnInit {

  bookingRequests: WpBookingRequest[] = [];
  searchForm: FormGroup | null = null;
  recordsByPage = 50;
  loading = false;
  totalRecords = 0;
  salesAgents: SalesAgent[] = [];
  pageRecordsOptions = [50, 100, 500];
  yearRange = "2010:" + moment().year();

  displayOptions = [
    { label: "Show all", value: 0 },
    { label: "New & Processing", value: 1},
    { label: "New", value: 2 },
    { label: "Processing", value: 3 },
    { label: "Done", value: 4 },
    { label: "Deleted", value: 5 }
  ];
  selectedDisplayOption = this.displayOptions[1].value;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.selectedDisplayOption = this.displayOptions[1].value;
    this.searchForm = this.builder.group({
      name: null,
      programmeName: null,
      startDate: null,
      endDate: null,
      duration: null,
      agent: null
    });
    this.httpService.getSalesAgents().subscribe(res => {
      this.salesAgents = res;
    });
    this.doMultiFilterSearch(0);
  }

  doMultiFilterSearch(offset: number){
    let rows = this.recordsByPage;
    let searchFormValue = this.searchForm!.value;

    let options = new WpBookingRequestSearchOptions(
      this.selectedDisplayOption,
      searchFormValue.name,
      searchFormValue.programmeName,
      searchFormValue.startDate==null?null:moment(searchFormValue.startDate).utc(true),
      searchFormValue.endDate==null?null:moment(searchFormValue.endDate).utc(true),
      searchFormValue.duration,
      searchFormValue.agent
    );
      this.loading = true;
      forkJoin({
        recordNumber:  this.httpService.getWpBookingRequestNumberByMultiFilters(options),
        bookingRequests: this.httpService.getWpBookingRequestsByMultiFilters(options, rows, offset)
      }).subscribe(({recordNumber, bookingRequests}) => {
        this.bookingRequests = bookingRequests;
        this.totalRecords = recordNumber;
        this.loading = false;
      });
  }

  updateStringFilter(event: any){
    if(event.target.value == "" || event.target.value.length > 2){
      this.doMultiFilterSearch(0);
    }
  }

  updateDurationFilter(event: any){
    this.checkDurationFormat();
    if(event.target.value == "" || event.target.value.length > 0){
      this.doMultiFilterSearch(0);
    }
  }

  checkDurationFormat() {
    this.searchForm!.get("duration")!.valueChanges.subscribe(val => {
      let index = val.indexOf(",");
      if (index != -1) {
        let newValue = val.substring(0, index) + "." + val.substring(index + 1, val.length);
        this.searchForm!.get("duration")!.setValue(newValue.replace(/[^0-9\.]/g, ""));
      } else {
        let newValue = val.replace(/[^0-9\.]/g, "");
        if (newValue != val) {
          this.searchForm!.get("duration")!.setValue(newValue);
        }
      }
    });
  }

  resetSearchBox(){
    this.searchForm!.get("searchTerm")!.setValue("");
  }

  lazyLoad(event: any){
    this.doMultiFilterSearch(event.first);
    window.scrollTo({top: 0, behavior: "auto"});
  }

}
